import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-dark">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Testo */}
        <div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-beige mb-6">
            Background & Experience
          </h2>
          <div className="space-y-4 text-beige text-lg leading-relaxed">
            <p>
              With over 15 years of experience as a tutor for established tutor agencies, 
              I have worked with a diverse range of students including SEND (Autism, ADHD, Dyslexia).
            </p>
            <p>
              My approach combines empathy and academia to ensure maximum success and 
              engagement with a proven track record.
            </p>
            <p>
              I hold a current DBS certificate and am up to date with Government-required 
              Safeguarding issues.
            </p>
            <p className="font-semibold">
              Due to high demand I can only offer online tuition.
            </p>
          </div>
        </div>

       
        <div className="bg-beige rounded-2xl p-0 h-[50vh] md:h-[60vh] overflow-hidden">
          <img
            src={`${process.env.PUBLIC_URL}/sharon.foto.jpg`}
            alt="Sharon Daley"
            className="w-full h-full object-contain bg-dark"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;